import { useEffect } from 'react';

import { useSelector } from 'react-redux';

import { useFlag } from 'src/hooks/flag';
import { useIntl } from 'src/hooks/intl';
import { getCurrentPullRequest } from 'src/redux/pull-request/selectors';
import { getIsReviewInProgress } from 'src/redux/pull-request/selectors/review-selectors';

import messages from './pending-review-warning-flag.i18n';

// This is a workaround because the pull request details page
// is class based. Once we convert that to a functional component
// we should change this to use a hook pattern.
export const PendingReviewWarningCheck = (): null => {
  const { showWarningFlag } = useFlag();
  const intl = useIntl();
  const currentPullRequest = useSelector(getCurrentPullRequest);
  const reviewInProgress = useSelector(getIsReviewInProgress);
  const currentPullRequestState = currentPullRequest?.state;

  useEffect(() => {
    if (
      currentPullRequestState !== 'OPEN' &&
      currentPullRequestState !== undefined &&
      reviewInProgress
    ) {
      let title;
      if (currentPullRequestState === 'MERGED') {
        title = intl.formatMessage(messages.mergedTitle);
      } else if (currentPullRequestState === 'DECLINED') {
        title = intl.formatMessage(messages.declinedTitle);
      } else {
        // This shouldn't happen but we need to have a fail safe
        title = intl.formatMessage(messages.closedTitle);
      }

      showWarningFlag(intl.formatMessage(messages.errorMessage), title, true);
    }
  }, [currentPullRequestState, reviewInProgress, intl, showWarningFlag]);
  return null;
};
